import {
  EventCategory,
  EventInput,
  EventOrganizer,
  EventPublication,
  EventStatus,
  MarketplaceEvent,
} from '@lib/types/event';

export interface EventDTO {
  id: string;
  slug: string;
  title: string;
  summary: string | null;
  description: string | null;
  category: EventCategory;
  bannerUrl: string | null;
  organizer?: EventOrganizer | null;
  publication: EventPublication;
  status: EventStatus;
  startsAt: string | null;
  endsAt: string | null;
  timeZone: string;
  venueName: string | null;
  addressLine: string | null;
  postalCode: string | null;
  city: string | null;
  state: string | null;
  country: string;
  officialUrl: string | null;
  registrationUrl: string | null;
  revision?: number;
  archivedAt?: string | null;
  createdAt: string;
  updatedAt: string;
  games: { id: string; name: string; slug: string }[];
}

export interface EventPageDTO {
  items: EventDTO[];
  total: number;
  page: number;
  limit: number;
}

export const createEvent = (dto: EventDTO): MarketplaceEvent => ({
  id: dto.id,
  slug: dto.slug,
  title: dto.title,
  summary: dto.summary,
  description: dto.description,
  category: dto.category,
  bannerUrl: dto.bannerUrl,
  organizer: dto.organizer
    ? {
        name: dto.organizer.name,
        id: dto.organizer.id,
        storeId: dto.organizer.storeId,
        storeSlug: dto.organizer.storeSlug,
        email: dto.organizer.email,
        eligible: dto.organizer.eligible,
        assignedAt: dto.organizer.assignedAt,
      }
    : null,
  publication: dto.publication,
  status: dto.status,
  startsAt: dto.startsAt,
  endsAt: dto.endsAt,
  timeZone: dto.timeZone,
  venueName: dto.venueName,
  addressLine: dto.addressLine,
  postalCode: dto.postalCode,
  city: dto.city,
  state: dto.state,
  country: dto.country,
  officialUrl: dto.officialUrl,
  registrationUrl: dto.registrationUrl,
  revision: dto.revision,
  archivedAt: dto.archivedAt,
  createdAt: dto.createdAt,
  updatedAt: dto.updatedAt,
  games: dto.games.map((game) => ({
    id: game.id,
    name: game.name,
    slug: game.slug,
  })),
});

export const eventRequest = (input: EventInput) => ({
  title: input.title.trim(),
  summary: input.summary || null,
  description: input.description || null,
  category: input.category,
  startsAt: input.startsAt || null,
  endsAt: input.endsAt || null,
  timeZone: input.timeZone.trim(),
  venueName: input.venueName?.trim() || null,
  addressLine: input.addressLine?.trim() || null,
  postalCode: input.postalCode || null,
  city: input.city?.trim() || null,
  state: input.state?.trim() || null,
  country: input.country.trim().toUpperCase(),
  officialUrl: input.officialUrl?.trim() || null,
  registrationUrl: input.registrationUrl?.trim() || null,
  gameIds: input.gameIds,
});
